<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-lx-cascades"></i> 角色列表
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<!-- <div class="handle-box">
				<el-input placeholder="角色名称" class="handle-input mr10" v-model="personName"></el-input>
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
			</div> -->
			<el-table :data="personList" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				style="width: 100%">
				<!-- <el-table-column prop="Id" label="ID" align="center" fixed></el-table-column> -->
				<el-table-column prop="Name" label="角色名称" align="center" fixed></el-table-column>
				<el-table-column prop="AddTime" label="添加时间" align="center" fixed></el-table-column>
				<el-table-column fixed="right" label="操作" width="200" align="center">
					<template #default="scope">
						<el-button @click="handleClick(scope.row)" type="text">查看</el-button>
						<el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- 编辑弹出框 查看弹出框-->
		<el-dialog :title="title" v-model="editVisible" width="30%">
			<el-form label-width="100px" ref="ruleForm" :model="ruleForm" :rules="rules">
				<el-form-item label="角色名称" prop="Name">
					<el-input v-model="ruleForm.Name" :disabled="isdisabled"></el-input>
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="editVisible = false">取 消</el-button>
					<el-button type="primary" @click="saveEdit('ruleForm')">确 定</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	import axios from 'axios';
	import qs from 'qs';
	export default {
		data() {
			return {
				ruleForm:[],
				title:'',
				editVisible:false,
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				personList: [],
				personName: '', //角色名称
				token: localStorage.getItem('access_token'),
			}
		},
		created() {
			this.getData()
		},
		methods: {
			//查看
			handleClick(row) {
				console.log(row)
				this.title = '查看'
				this.isdisabled = true
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetRoleModel?roleId=" + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					this.ruleForm = res.data.Data
					this.editVisible = true
				})
			},
			// 编辑
			handleEdit(index, row) {
				this.title = '编辑'
				this.isdisabled = false
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetRoleModel?roleId=" + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					this.ruleForm = res.data.Data
					this.editVisible = true
				})
			},
			//保存编辑
			saveEdit(ruleForm) {
				if (this.title == '编辑') {
					this.$refs[ruleForm].validate((valid) => {
						if (valid) {
							axios({
								method: 'post',
								url: this.$store.state.pcurl + "UpdateRole",
								data: this.ruleForm,
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								if (res.data.Message == '请求成功') {
									this.editVisible = false
									this.$message({
										message: '修改成功',
										type: 'success'
									})
									this.getData()
								} else {
									this.$message.error('修改失败');
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				}else{
					this.editVisible = false
				}
			},
			handleNodeClick(data) {
				console.log(data);
			},
			getData() {
				this.personList = []
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetRoles",
					headers: {
						Authorization: 'bearer ' + this.token
					}
				}).then((res) => {
					console.log(res.data.Data)
					if (res.data.Message == '请求成功') {
						res.data.Data.forEach((x)=>{
							x.AddTime = x.AddTime.replace('T',' ')
							if(x.Name !='会员'){
								this.personList.push(x)
							}
						})
					} else {
						this.$message.error('角色列表获取失败')
					}
				})
			},
			// handleSearch(){

			// },
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}
	
</style>
